(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-winter-home"] && !Shopify.designMode) return;
  try {
    
function initWbStudio(root=document){
root.querySelectorAll('.wb-studio-products').forEach(section=>{
 const track=section.querySelector('.wb-studio-track');
 if(!track||track.dataset.ready)return;
 track.dataset.ready='true';
 const buttons=section.querySelectorAll('[data-wb-slide]');
 const update=()=>buttons.forEach(b=>b.disabled=Number(b.dataset.wbSlide)<0?track.scrollLeft<2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2);
 buttons.forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.wbSlide)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
 track.addEventListener('scroll',update,{passive:true});
 new ResizeObserver(update).observe(track);update();
});
}
function initWbAll(root=document){
root.querySelectorAll('#wb-all-products').forEach(section=>{
 const grid=section.querySelector('.wb-studio-grid'),loader=section.querySelector('[data-wb-load]'),link=loader?.querySelector('[data-wb-next]'),status=loader?.querySelector('[data-wb-load-status]');
 if(!grid||!link||section.dataset.infiniteReady||!('IntersectionObserver' in window))return;
 section.dataset.infiniteReady='true';
 let next=link.href,busy=false;
 const seen=new Set([...grid.children].map(x=>x.dataset.variantId));
 const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))load();},{rootMargin:'600px 0px'});
 async function load(){
  if(busy||!next)return;
  busy=true;observer.unobserve(loader);link.hidden=true;status.textContent='Loading more products…';grid.setAttribute('aria-busy','true');
  try{
   const url=new URL(next,location.href);url.hash='';url.searchParams.set('section_id',section.dataset.sectionId);
   const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
   const response=await fetch(url);if(!response.ok)throw Error('Unable to load products');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html'),incoming=doc.querySelector('#wb-all-products .wb-studio-grid');
   if(!incoming)throw Error('Missing product grid');
   const fragment=document.createDocumentFragment();let count=0;
   [...incoming.children].forEach(card=>{const id=card.dataset.variantId;if(!id||seen.has(id))return;seen.add(id);fragment.append(document.importNode(card,true));count++;});
   grid.append(fragment);
   const following=doc.querySelector('#wb-all-products [data-wb-next]')?.getAttribute('href');
   next=following?new URL(following,location.href).href:null;
   status.textContent=next?'More products loaded.':'You’ve viewed all products.';
   if(next){link.href=next;observer.observe(loader);}
  }catch(error){status.textContent='Couldn’t load more products. ';link.hidden=false;link.textContent='Try again';}
  finally{busy=false;grid.removeAttribute('aria-busy');}
 }
 link.addEventListener('click',e=>{e.preventDefault();load();});
 observer.observe(loader);
});
}
initWbAll();
document.addEventListener('shopify:section:load',e=>initWbAll(e.target));
initWbStudio();
document.addEventListener('shopify:section:load',e=>initWbStudio(e.target));

  } catch(e) { console.error(e); }
})();
})();
